import get from 'lodash/get';
import {mapGetters, mapState} from 'vuex';
import {fetchAndCache} from '@/utils/cached-promise';
import {ProductApi} from '@/api/product';
import {Cookie} from '@/utils/cookie';
import {getMessageByCode} from '@/components/containers/pdp/utils/retailers-helper';

const rpaCookieName = 'trek_rpa_user_search_phrase';
const rpaCookieExpirationMinutes = 1440;

const ProductStockData = {
  created() {
    this.$on('loadRpaResults', this.loadStockData);
    this.$on('updateRpaResults', this.updatedLocationStockData);
  },
  computed: {
    ...mapGetters('pdp', ['rpaViewInStock']),
    ...mapState('pdp', ['rpaViewInStock']),
  },
  methods: {
    /**
     * Get value of in stock filter.
     * @return {*}
     */
    getInStockOnly() {
      const inStockEl = document.querySelector('input[name="rpa-instock-toggle-switch"]');
      return inStockEl ? inStockEl.checked : this.rpaViewInStock;
    },

    /**
     * Get stock message with translated label and description.
     * @param code
     * @return {{}|{code: string, cssClass: string, description: string, label: string, explanation: string}}
     */
    getStockMessageByCode(code) {
      let stockMessage = getMessageByCode(code);
      if (!stockMessage) {
        return {};
      }

      stockMessage.label = this.bp(stockMessage.label);
      stockMessage.description = stockMessage.description ? this.bp(stockMessage.description) : '';
      stockMessage.explanation = stockMessage.explanation ? this.bp(stockMessage.explanation) : '';

      return stockMessage;
    },

    /**
     * Load stock data and initialize stock message.
     * @param productCode
     */
    loadStockData(productCode) {
      const variant = this.product.variants.find((variant) => variant.code === productCode);
      if (!variant || !Object.keys(variant).length) {
        this.stockData = {};
        return;
      }
      const locationText = this.stockData.locationPostalCode || Cookie.get(rpaCookieName) || '';
      const options = {
        productCode,
        retailersMax: 10,
        inStockOnly: this.getInStockOnly(),
        isInStockOnline: get(variant, 'isInStockOnline', false),
        locationText,
        showLocallyWidget: this.showLocallyWidget,
      };
      this.isLoadingStockData = true;
      fetchAndCache(
        `${productCode}-${locationText}-${options.inStockOnly}`,
        ProductApi.getStockAvailability(options)
      ).then((stockData) => {
        this.updateCachedStockData(stockData, locationText);
      });
    },
    updateCachedStockData(stockData, locationText) {
      this.stockData = stockData;
      this.isLocationPostalCodeCorrect = true;
      this.stockMessage = this.getStockMessageByCode(stockData.globalStockStatus);
      this.isLoadingStockData = false;

      // Set RPA cookie.
      const rpaCookieValue = locationText || this.stockData.locationPostalCode || stockData.locationPostalCode;
      Cookie.set(rpaCookieName, rpaCookieValue, rpaCookieExpirationMinutes);
    },
    checkRetailersSearchList(stockData, locationText) {
      if (!('retailers' in stockData) || !stockData.retailers || !stockData.retailers.length) {
        this.stockData.locationPostalCode = Cookie.get(rpaCookieName);
        this.isLocationPostalCodeCorrect = false;
      } else {
        this.updateCachedStockData(stockData, locationText);
      }
    },
    updatedLocationStockData(locationText, productCode) {
      const variant = this.product.variants.find((variant) => variant.code === productCode);
      if (!variant || !Object.keys(variant).length) {
        this.stockData = {};
        return;
      }
      if (locationText === '') {
        locationText = Cookie.get(rpaCookieName);
      }
      const options = {
        productCode,
        retailersMax: 10,
        inStockOnly: this.getInStockOnly(),
        isInStockOnline: get(variant, 'isInStockOnline', false),
        locationText,
        showLocallyWidget: this.showLocallyWidget,
      };
      this.isLoadingStockData = true;
      fetchAndCache(
        `${productCode}-${locationText}-${options.inStockOnly}`,
        ProductApi.getStockAvailability(options)
      ).then((stockData) => {
        this.checkRetailersSearchList(stockData, locationText);
      });
    },
  },
  data() {
    return {
      isLoadingStockData: false,
      stockMessage: {},
      stockData: {},
      isLocationPostalCodeCorrect: true,
    };
  },
};

export {ProductStockData};
